import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getAuth} from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCLxcyiWuvHasCbzxAo7FZPnraOVV2XF54",
  authDomain: "alumini-reconnect.firebaseapp.com",
  databaseURL: "https://alumini-reconnect-default-rtdb.firebaseio.com",
  projectId: "alumini-reconnect",
  storageBucket: "alumini-reconnect.appspot.com",
  messagingSenderId: "844337343359",
  appId: "1:844337343359:web:59ed7f21030610b1f1884a",
  measurementId: "G-EELZCDRPXS"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);